var React = require('react');

function PaperPlane (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"paper-plane","d":"M17.228.278.979,9.648A1.875,1.875,0,0,0,1.2,13l4.464,1.848v3.3a1.877,1.877,0,0,0,3.383,1.117l1.711-2.308,4.371,1.8a1.879,1.879,0,0,0,2.57-1.449l2.32-15.124A1.878,1.878,0,0,0,17.228.278ZM7.541,18.147V15.624l1.43.59Zm8.3-1.121-6.007-2.48,5.476-7.9a.626.626,0,0,0-.926-.828l-8.261,7.2L1.917,11.273,18.165,1.9Z","transform":"translate(-0.043 -0.025)","fill":"#fff"}));
}

PaperPlane.defaultProps = {"width":"20","height":"19.998","viewBox":"0 0 20 19.998"};

module.exports = PaperPlane;

PaperPlane.default = PaperPlane;
